var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.625 0.5V1.90736C9.99223 2.04977 11.2218 2.65417 12.1492 3.56189C13.2183 4.59994 13.8793 6.04342 13.8793 7.64524V11.3158C14.8489 11.4099 15.625 12.2143 15.625 13.2158C15.625 14.2821 14.7452 15.125 13.6886 15.125H11.5717C11.2762 16.8359 9.78772 18.125 8 18.125C6.21208 18.125 4.72519 16.8285 4.42875 15.125H2.31144C1.25484 15.125 0.375 14.2821 0.375 13.2158C0.375 12.2143 1.15105 11.4099 2.12073 11.3158V7.64524C2.12073 4.66123 4.42944 2.21376 7.375 1.90733V0.5H8.625ZM4.375 13.875H5H11H11.625H13.6886C14.0796 13.875 14.375 13.5671 14.375 13.2158C14.375 12.8644 14.0796 12.5565 13.6886 12.5565H13.2543C12.9091 12.5565 12.6293 12.2767 12.6293 11.9315V7.64524C12.6293 6.39561 12.1155 5.27105 11.2776 4.45789L11.2756 4.45593C10.4348 3.63262 9.27896 3.125 8 3.125C5.42953 3.125 3.37073 5.16675 3.37073 7.64524V11.9315C3.37073 12.2767 3.09091 12.5565 2.74573 12.5565H2.31144C1.92035 12.5565 1.625 12.8644 1.625 13.2158C1.625 13.5671 1.92036 13.875 2.31144 13.875H4.375ZM5.70826 15.125C5.98294 16.1329 6.90559 16.875 8 16.875C9.09656 16.875 10.0192 16.1374 10.2926 15.125H5.70826Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.23f1fdb72faa3f9dbf37d1a922e7c1b8.svg";
export { ForwardRef as ReactComponent };